export const SUBMIT_REGISTER_OTP_LOADING = "SUBMIT_REGISTER_OTP_LOADING"
export const UPDATE_REGISTER_OTP_FORM = "UPDATE_REGISTER_OTP_FORM"
export const UPDATE_REGISTER_OTP_DATA_FORM = "UPDATE_REGISTER_OTP_DATA_FORM"